// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-popup {
  max-height: 70vh;
  overflow-y: auto;
  background: var(--surface-primary);
  border-radius: 4px;
  box-shadow: 0 0 12px var(--box-shadow-primary);
  display: flex;
  flex-direction: column;
  border: 1px solid var(--border-primary);
}

.settings-popup::-webkit-scrollbar {
  width: 4px;
}

.settings-popup::-webkit-scrollbar-thumb {
  background-color: var(--surface-disabled);
  border-radius: 2px;
}

.settings-popup::-webkit-scrollbar-track {
  background-color: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/AdvanceChartWidget/components/common/SettingsPopup.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":[".settings-popup {\n  max-height: 70vh;\n  overflow-y: auto;\n  background: var(--surface-primary);\n  border-radius: 4px;\n  box-shadow: 0 0 12px var(--box-shadow-primary);\n  display: flex;\n  flex-direction: column;\n  border: 1px solid var(--border-primary);\n}\n\n.settings-popup::-webkit-scrollbar {\n  width: 4px;\n}\n\n.settings-popup::-webkit-scrollbar-thumb {\n  background-color: var(--surface-disabled);\n  border-radius: 2px;\n}\n\n.settings-popup::-webkit-scrollbar-track {\n  background-color: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
